import React, { useEffect, useRef, useState } from "react";

const SelectDropdown = ({ options, value, onChange, labelText, className, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasValue, setHasValue] = useState(false);
  const dropDown = useRef(null)

  useEffect(() => {
    if (value !== '' || value.length > 0) {
      setHasValue(true)
    } else {
      setHasValue(false)
    }
    const onClickOutside = (event) => {
      if (dropDown.current && !dropDown.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [dropDown, value]);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
    setHasValue(true)
  };

  return (
    <div className={`custom-select ${className ? className : ''} ${isOpen ? 'open-select' : ''} ${hasValue ? 'selected' : ''}`} ref={dropDown}>
      <div className='select-header form-control ' onClick={() => setIsOpen(!isOpen)}>
        {!value && <label className="form-label">{labelText}</label>}
        {value && <div className="value">{value}</div>}
      </div>
      {isOpen && (
        rest.name === 'retriveBank' ? <ul className="select-options">
          {options ? options.map((option, key) => (
            <li key={key} onClick={() => handleOptionClick(option)}>
              {option.name}
              <input type='radio' className='form-check-input' readOnly checked={value===option.name} />
            </li>
          )) : null}
        </ul> : <ul className="select-options">
          {options ? options.map((option, key) => (
            <li key={key} onClick={() => handleOptionClick(option)}>
              {option}
              <input type='radio' className='form-check-input' readOnly checked={value===option} />
            </li>
          )) : null}
        </ul>
      )}
    </div>
  );
};

export default SelectDropdown;